import { useStore } from 'effector-react';
import Tabbar from '@components/Tabbar';
import { IconHorizontal, IconOverlap, IconSplit, IconVertical } from './icons';
import type { CompareMode } from '../types';
import { $compareState, $compareStateApi } from '../compareStores';

const tips = ['左右分屏', '上下分屏', '混合对比', '重叠对比'];

const modeArr: CompareMode[] = ['horizontal', 'vertical', 'split', 'overlap'];
const getIndex = (mode: CompareMode) =>
  modeArr.findIndex((x) => x === mode) ?? 0;

export function CompareModeTabbar() {
  const { mode } = useStore($compareState);
  const tabs = [
    <IconHorizontal active={mode === 'horizontal'} />,
    <IconVertical active={mode === 'vertical'} />,
    <IconSplit active={mode === 'split'} />,
    <IconOverlap active={mode === 'overlap'} />,
  ];

  const handleChange = (index: number) => {
    const val = modeArr[index];
    $compareStateApi.setMode(val);
  };

  return (
    <div className="absolute bottom-20 w-190">
      <Tabbar
        tabs={tabs}
        tips={tips}
        activeIndex={getIndex(mode)}
        onChange={(index) => handleChange(index)}
      />
    </div>
  );
}
